import React from 'react';
import TableHeader from '../TableHeader';
import moment from 'moment';

const WalletsList = ({
  wallets, total
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Wallets list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} wallets</p>
        </div>
      </div>

      <div className='Table Table--wallet-list'>
        {(() => {
          let columnHeaders = [
            {
              label: 'Id',
              sortKey: 'id'
            },
            {
              label: 'Wallet address'
            },
            {
              label: 'Yay User ID'
            },
            {
              label: 'Referral code',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Referreds count',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Referrer Wallet ID',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Created at',
              sortKey: 'created_at',
              className: 'Table__col--ta-c'
            },
            {
              label: ''
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {wallets.map((wallet) => (
          <div className='Table__row' key={wallet.id} data-x={wallet}>
            <div className='Table__col'>
              {wallet.id}
            </div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={wallet.bagId ? `/${gon.currentProvider}/bag/${wallet.bagId}` : `/${gon.currentProvider}/wallet/${wallet.id}`}
              >
                {wallet.walletAddress}
              </a><br/>
              <div className='Badge--container'>
                {
                  wallet.forDashboard && <span className='Badge Badge--gray'>for dashboard</span>
                }
                {
                  wallet.forApp && <span className='Badge Badge--blue'>for app</span>
                }
              </div>
            </div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/yay/users/${wallet.yayUserId}`}
              >
                {wallet.yayUserId}
              </a>
            </div>
            <div className='Table__col Table__col--ta-c'>
              {wallet.referralCode}
            </div>
            <div className='Table__col Table__col--ta-c'>

              {
                wallet.referredCount ?
                <a
                className='Table__a'
                href={`/${gon.currentProvider}/wallet?referrer_id=${wallet.id}`}>
                  {wallet.referredCount}
                </a>
                :
                wallet.referredCount
              }
            </div>
            <div className='Table__col Table__col--ta-c'>
              {
                wallet.referrerId ?
                  <a
                  className='Table__a'
                  href={`/${gon.currentProvider}/wallet?id=${wallet.referrerId}`}>
                    {wallet.referrerId}
                  </a>
                  :
                  wallet.pendingReferrerCode &&
                    <React.Fragment>
                      {wallet.pendingReferrerCode} <span className='Badge Badge--yellow'>Pending</span>
                    </React.Fragment>
              }
            </div>
            <div className='Table__col Table__col--ta-c'>
              {moment(wallet.createdAt).format('YYYY-MM-DD HH:mm')}
            </div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/${gon.currentProvider}/wallet/${wallet.id}/staking`}>
                  Staking
              </a>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default WalletsList;
